// import { Create, List, DetailCreate, Result, DetailList, DetailEdit } from "../Components";

export default [
    {
        path: "/training/exam-item/list",
        component: () => import("./List.vue"),
        name: "training-exam-item-list",
        meta: {
            requiresAuth: true,
        },
    },

    // {
    //     path: "/training/exam-item/detail-list",
    //     component: DetailList,
    //     name: "training-exam-item-detail-list",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    // {
    //     path: "/training/exam-item/detail",
    //     component: DetailCreate,
    //     name: "training-exam-item-detail",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    // {
    //     path: "/training/exam-item/detail-edit/:id",
    //     component: DetailEdit,
    //     name: "training-exam-item-detail-edit",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    // {
    //     path: "/training/exam-item/result",
    //     component: Result,
    //     name: "training-exam-item-result",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    {
        path: "/training/exam-item/create",
        component: () => import("./Create.vue"),
        name: "training-exam-item-create",
        meta: {
            requiresAuth: true,
        },
    },
];
